var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvalCopy10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 489
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f3f8",
    fillRule: "evenodd",
    d: "M-167.64 521.336c143.322 12.54 311.197-89.883 323.74-233.25S85.203-.613-58.12-13.153-350.374 99.315-362.917 242.68s51.954 266.118 195.276 278.657z"
  })));
}
export default SvgOvalCopy10;